/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest,
  PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
  PostApiV1AccesscontrolPermissionsUpsertBatch400,
  PostApiV1AccesscontrolPermissionsUpsertBatch401,
  PostApiV1AccesscontrolPermissionsUpsertBatch500,
} from "../../types/accessControlPermissionsController/PostApiV1AccesscontrolPermissionsUpsertBatch.ts";

function getPostApiV1AccesscontrolPermissionsUpsertBatchUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/accesscontrol/permissions/upsert-batch` as const,
  };
  return res;
}

/**
 * @description Cria ou atualiza permissões para todos os usuários de um role em múltiplos controllers. **(Requer Authorization para autenticação)**
 * @summary Upsert permissões em lote (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/permissions/upsert-batch}
 */
export async function postApiV1AccesscontrolPermissionsUpsertBatch(
  data?: PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1AccesscontrolPermissionsUpsertBatch400
      | PostApiV1AccesscontrolPermissionsUpsertBatch401
      | PostApiV1AccesscontrolPermissionsUpsertBatch500
    >,
    PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest
  >({
    method: "POST",
    url: getPostApiV1AccesscontrolPermissionsUpsertBatchUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
